import { FormattedMessage } from 'react-intl';
import React from 'react';

import styles from './help.scss';

const Help = () => (
  <a
    href="mailto:support@dreamhack.com"
    className={styles.icon}
  >
    <i className="far fa-question-circle" />
    {' '}
    <FormattedMessage
      id="seatmap.components.help.iNeedHelp"
      defaultMessage="I need help"
    />
  </a>
);

export default Help;
